import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function MedjunarodnoPrivatnoPravo() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Međunarodno privatno pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Međunarodno privatno pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Međunarodno privatno pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 7
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Međunarodno privatno pravo ima za cilj da se izučavanjem
                predmeta Međunarodno privatno pravo steknu teorijska i praktična
                znanja o osnovnim institutima međunarodnog privatnog prava. S
                obzirom na evro-atlanske integracije Crne Gore i sve veći priliv
                stranih investicija povećan protok ljudi roba i usluga cilj ovog
                predmeta je i razumijevanje i savladavanje privatnopravnih
                odnosa sa međunarodnim elementom kako bi studenti razvili
                sposobnosti i znanja da sve veći broj privatnopravnih situacija
                sa međunarodnim elementom u budućnosti uspješno rješavaju.
                Sticanje znanja u oblastima: sukoba zakona primjene stranih
                sudskih odluka u našem pravu pravnom položaju stranaca...
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Na kraju uspješno savladanog studijskog sadržaja ovog predmeta
                studenti će biti osposobljeni da: uoče i objasne pravne odnose
                sa elementom inostranosti; detaljno razumiju i objasne pojmove
                međunarodno privatnog prava; razviju sposobnost tumačenja i
                primjene pravnih izvora; utvrde i primijene mjerodavno pravo za
                konkretan slučaj; ustanove da li su ispunjeni uslovi za
                priznanje i izvršenje strane sudske odluke; samostalno primijene
                kolizijska pravila i pravila o međunarodnoj nadležnosti i
                priznavanju stranih odluka; pronađu rješenja za primjere iz
                prakse;
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                <strong>Teorijska nastava:</strong>
                Pojam i predmet međunarodnog privatnog prava; Odnos sa drugim
                granama prava; Način rješavanja sukoba zakona i sukoba
                jurisdikcija; Izvori međunarodnog privatnog prava i hijerarhija
                izvora prava; Razvoj međunarodnog privatnog prava; Kolizione
                norme; Problem kvalifikacije; Uzvraćanje i upućivanje na dalje
                pravo (renvoi); Klauzula odstupanja od redovnog mjerodavnog
                prava; Javni poredak i norme neposredne primjene; Izigravanje
                zakona (fraus legis); Pojam i vrste međunarodne sudske
                nadležnosti; Biranje nadležnog suda i neprikladan sud; Položaj
                stranaca pred domaćim sudovima; Međunarodna pravna pomoć; Pojam
                i sistemi priznanja i izvršenja stranih sudskih odluka;
                Međunarodna trgovačka arbitraža; Prava stranaca da stupaju u
                građansko pravne odnose; Tačke vezivanja; Određivanje
                mjerodavnog prava; Mjerodavno pravo za pravni položaj fizičkih
                lica; Mjerodavno pravo za pravna lica; Mjerodavno pravo za
                stvarnopravne odnose; Mjerodavno pravo za ugovorne odnose;
                Mjerodavno pravo za vanugovorne odnose; Mjerodavno pravo za
                porodične onose; Mjerodavno pravo za nasleđivnje.
              </p>
              <p>
                <strong>Praktična nastava:</strong>
                Praktična nastava će se izvoditi van prostorija fakulteta kroz
                posjete nadležnim državnim organima kao i na predavanjima i
                vježbama kroz analizu sudske prakse, analiza praktičnih
                primjera, utvrđivanje mjerodavnog prava za konkratne slučajeve i
                simulacijom suđenja.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Nastava se izvodi kroz predavanja, diskusije, izrade samostalnih
                istraživačkih radova – seminarskih radova, upoznavanje sa
                sudskom praksom crnogorskih sudova (u sudu ili u okviru nastave
                na fakultetu) i analizu sudske prakse od strane studenata.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P + 2V</td>
                    <td>
                      Pojam i predmet međunarodnog privatnog prava; Odnos sa
                      drugim granama prava; Način rješavanja sukoba zakona i
                      sukoba jurisdikcija
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P + 2V</td>
                    <td>
                      Izvori međunarodnog privatnog prava i hijerarhija izvora
                      prava; Razvoj međunarodnog privatnog prava; Kolizione
                      norme; Problem kvalifikacije
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P + 2V</td>
                    <td>
                      Uzvraćanje i upućivanje na dalje pravo (renvoi); Klauzula
                      odstupanja od redovnog mjerodavnog prava; Javni poredak i
                      norme neposredne primjene; Izigravanje zakona (fraus
                      legis);
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P + 2V</td>
                    <td>
                      Pojam i vrste međunarodne sudske nadležnosti; Biranje
                      nadležnog suda i neprikladan sud
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P + 2V</td>
                    <td>
                      Položaj stranaca pred domaćim sudovima; Međunarodna pravna
                      pomoć + Praktična nastava. Posjeta nadležnim državnim
                      organima. Analiza prakse.
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P + 2V</td>
                    <td>
                      Pojam i sistemi priznanja i izvršenja stranih sudskih
                      odluka; Međunarodna trgovačka arbitraža + Praktična
                      nastava. Analiza sudske prakse i analiza praktičnih
                      primjera.
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P + 2V</td>
                    <td>
                      Prava stranaca da stupaju u građansko pravne odnose; Tačke
                      vezivanja;
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P + 2V</td>
                    <td>
                      Mjerodavno pravo za pravni položaj fizičkih lica;
                      Mjerodavno pravo za pravna lica
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P + 2V</td>
                    <td>Mjerodavno pravo za stvarnopravne odnose</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P + 2V</td>
                    <td>
                      Mjerodavno pravo za nasleđivnje. + Praktična nastava.
                      Utvrđivanje mjerodavnog prava u konkretnom slučaju.
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P + 2V</td>
                    <td>Mjerodavno pravo za ugovorne odnose</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P + 2V</td>
                    <td>Mjerodavno pravo za vanugovorne odnose</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P + 2V</td>
                    <td>
                      Mjerodavno pravo za porodične onose + Praktična nastava.
                      Utvrđivanje mjerodavnog prava za konkratne slučajeve.
                      Simulacija suđenja.
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5 č / 3.45h</td>
                            <td>Ukupno: 90 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 2.15h</td>
                            <td>Nastava + završni ispit: 65 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1.3h</td>
                            <td>Priprema i ovjera semestra: 10 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MedjunarodnoPrivatnoPravo;
